// Listed up front; the view itself (./fretboard-explorer.tsx) loads on demand.
export const id = 'fretboard-explorer';
export const title = 'Fretboard explorer';
export const order = 10;
